import { useContext } from 'react';

import { FormEngineContext } from '../context';

export const useFormEngineContext = () => {
  return useContext(FormEngineContext);
};
